import { L7Config } from '@zerops/models/project';
import { L7ConfigFormValue } from './l7-config-dialog.form';

const BOOLEAN_FIELDS = [
  'multi_accept', 'reset_timedout_connection', 'proxy_request_buffering',
  'proxy_buffering', 'sendfile', 'tcp_nopush', 'tcp_nodelay', 'gzip',
  'open_file_cache', 'open_file_cache_errors', 'server_tokens'
];

export const transformL7FormDataToPayload = (
  formValue: L7ConfigFormValue
) => {
  const booleanFields = new Set(BOOLEAN_FIELDS);

  return {
    values: Object.entries(formValue).map(([ name, value ]) => ({
      name,
      value: booleanFields.has(name)
        ? (value === 'dflt' ? null : (value ? 'on' : 'off'))
        : (value === '' ? null : value)
    }))
  };
}

export const transformResponseToL7FormData = (data: L7Config[]) => {
  const formValues: Partial<L7ConfigFormValue> = {};

  data?.forEach((item) => {
    const value = item.current || '';

    if (BOOLEAN_FIELDS.includes(item.name)) {
      // Set 'dflt' if no current value (use default), otherwise convert "on"/"off" to boolean
      if (!item.current || item.current === '') {
        (formValues as any)[item.name] = 'dflt';
      } else {
        (formValues as any)[item.name] = value === 'on';
      }
    } else {
      // Keep as string for other fields (empty string means use default)
      (formValues as any)[item.name] = value;
    }
  });

  return formValues;
}

